import { useEffect } from "react";
import { B1MetadataCard } from "./card";
import { B1MetadataNew } from "./new";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { B1MetadataTable } from "./table";

export default function B1Metadata() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Métadonnées B1");
  }, []);

  return (
    <Routes>
      <Route index element={<B1MetadataTable />} />
      <Route path="/new" element={<B1MetadataNew />} />
      <Route path=":id" element={<B1MetadataCard />} />
    </Routes>
  );
}
